//  ANGULAR ----------------------------------------------
import { Routes } from "@angular/router";
import { autoLoginPartialRoutesGuard } from "angular-auth-oidc-client";

//  CUSTOM -----------------------------------------------
import { RedirectComponent } from "@shared/components";
import { HomeComponent } from "@features/index";
import { HistoryComponent } from "@features/history/history.component";

export const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  { path: "redirect", component: RedirectComponent },
  {
    path: "home",
    component: HomeComponent,
    canActivate: [autoLoginPartialRoutesGuard],
  },
  {
    path: "history/:sequenceNumber/:date/:seat",
    component: HistoryComponent,
    canActivate: [autoLoginPartialRoutesGuard],
  },
  {
    path: "**",
    redirectTo: "home",
  },
];
